module.exports = __webpack_public_path__ + "static/media/info.f584526d.svg";